import { Action, Selector, State, StateContext } from '@ngxs/store';
import { Injectable } from '@angular/core';
import { UserPrivilegeEnum } from '../../../../enums/rights/user-privilege.enum';
import { ResetStateDefaults } from '../../../base-action-class.model';
import { RChat } from './r-chat.action';

interface RChatXsStateModel{
  viewChat: string;
  createChat: string;
  deleteChat: string;
}

const getDefaults = (): RChatXsStateModel => ({
  viewChat: null,
  createChat: null,
  deleteChat: null
});

@State<RChatXsStateModel>({
  name: 'rChat',
  defaults: getDefaults()
})
@Injectable()
export class RChatXsState{

  //region SELECTOR

  @Selector()
  static canViewChat(state: RChatXsStateModel): boolean {
    return state.viewChat != null;
  }

  @Selector()
  static canCreateChat(state: RChatXsStateModel): boolean {
    return state.createChat != null;
  }

  @Selector()
  static canDeleteChat(state: RChatXsStateModel): boolean {
    return state.deleteChat != null;
  }
  //endregion

  //region ACTIONS
  @Action(RChat.SetChatPrivileges)
  public setChatPrivileges(ctx: StateContext<RChatXsStateModel>, action: RChat.SetChatPrivileges) {
    const state = ctx.getState();
    const chatPrivileges = [...action.activeUserRightInfoDtoModel.chatPrivileges];

    //find user privilege data model
    const viewChat = chatPrivileges.find(id => id === UserPrivilegeEnum.VIEW_CHAT);
    const createChat = chatPrivileges.find(id => id === UserPrivilegeEnum.CREATE_CHAT_ENTRY);
    const deleteChat = chatPrivileges.find(id => id === UserPrivilegeEnum.DELETE_CHAT_ENTRY);

    //set the state
    ctx.setState({
      ...state,
      viewChat: viewChat,
      createChat: createChat,
      deleteChat: deleteChat
    });
  }

  @Action(ResetStateDefaults)
  public resetDefaults(ctx: StateContext<RChatXsStateModel>): void {
    ctx.setState({...getDefaults()});
  }
  //endregion
}
